import styled from "styled-components";
import { responsive } from "theme/reponsive";

export const BournvitaBG = styled.div<{ url?: string }>`
   background-image: url(${({ url }) => url && url});
   width: 100%;
   height: 584px;
   @media screen and (max-width: 768px) {
      height: auto;
   }
`;

export const BournvitaDivider = styled.div`
   display: flex;
   width: 100%;
   padding-left: 80px;
   padding-right: 80px;
   justify-content: space-between;
   padding-top: 30px;
   .bournvita-text {
      width: 50%;
      margin-top: 79px;
      color: #fff;
      h2 {
         font-size: 70px;
         line-height: 65px;
         font-weight: 700;
         margin-top: 14px;
      }
      p {
         margin-top: 21px;
         font-size: 16px;
         font-weight: 700;
         line-height: 24px;
         padding-right: 50px;
      }
      @media screen and (max-width: 768px) {
         width: 100%;
         h2 {
            font-size: 40px;
            line-height: 45px;
         }
         p {
            font-size: 12px;
            padding-right: 0px;
         }
      }
   }
   .bournvita-img {
      width: 50%;
      img {
         width: 607px;
         height: 500px;
         margin-top: 53px;
      }
      @media screen and (max-width: 768px) {
         width: 100%;
         img {
            margin-bottom: -5px;
            width: 90%;
            height: auto;
            margin-top: 20px;
         }
      }
   }
   @media screen and (max-width: 768px) {
      flex-direction: column;
      padding-left: 10px;
      padding-right: 10px;
   }
`;

export const InfoSectionContainer = styled.div`
   width: 100%;
   padding-left: 70px;
   padding-right: 70px;
   margin-top: 50px;
   .no-margin {
      margin-top: 30px;
      padding: 30px 30px 0;

      ${responsive("$medium")`
         padding: 1rem;
         margin-top: 0;
      `};
   }
   .powered {
      font-weight: 400;
      font-size: 16px;
      line-height: 20px;
      color: #9d9595;
      margin-top: 37px;
   }
   .enquiries {
      font-weight: 400;
      font-size: 16px;
      line-height: 20px;
      color: #9d9595;
      margin-top: 37px;
   }
   .advert-footer {
      margin-top: 28px;
      display: flex;
      gap: 20px;
      margin-bottom: 139px;
      align-items: center;
      .logo-cover {
         height: 63px;
         padding-top: 28px;
      }
      .logo-cover1 {
         height: 63px;
      }
   }

   form.bootcamp-form {
      width: 100%;
      box-shadow: 0 3px 25px rgb(0 0 0 / 4%);
      border-radius: 5px;
      padding: 2rem;
      margin: 0 auto;

      ${responsive("$medium")`
         padding: 2rem;
         margin: 0 auto 3rem;
      `};
   }
   @media screen and (max-width: 768px) {
      padding-left: 10px;
      padding-right: 10px;
      margin-top: 20px;
   }
`;

export const InfoSection = styled.div`
   display: flex;
   flex-direction: column;
   .info-text {
      width: 100%;
      h4 {
         color: #666666;
         margin-bottom: 8px;
      }
      p {
         color: #666666;
         font-size: 16px;
         font-weight: 400;
         line-height: 20px;
      }
      .paragraph-line {
         line-height: 25px;
      }
      ul {
         margin-top: 5px !important;
         padding-left: 25px;
         color: #666666;
      }
      .no-list-style {
         list-style: none;
         padding: 0;
      }
      .inline-list-item {
         display: inline-flex;
         align-items: center;
      }
      button {
         margin-top: 30px;
         width: 242px;
         background-color: #412f7b;
         border-radius: 5px;
      }
      a {
         color: #3578e5;
         margin-left: 4px;
         margin-right: 4px;
      }
      .apply-button {
         text-decoration: none;
      }
   }
   .info-img {
      width: 100%;
      button {
         background-color: #412f7b;
      }
   }
   @media screen and (max-width: 768px) {
      .info-img {
         width: 100%;
         margin-top: 20px;
         img {
            width: 96%;
         }
      }
      .info-text {
         width: 100%;
      }
   }
`;

export const AfricaFestBanner = styled.div<{ url?: string }>`
   background-image: url(${({ url }) => url && url});
   width: 100%;
   max-width: 100% !important;
   background-repeat: no-repeat;
   background-position: center;
   background-size: cover;
   @media screen and (max-width: 768px) {
      height: auto;
   }
`;

export const AfricaFestDivider = styled.div`
   display: flex;
   width: 100%;
   padding: 80px 80px 30px 80px;
   justify-content: space-between;
   color: #836085;
   .bournvita-text {
      width: 50%;
      img {
         width: 320px;
         height: 170px;
      }
      h2 {
         font-size: 34px;
         line-height: 35px;
         font-weight: 700;
         margin: 12px 0;
      }
      p {
         margin-top: 18px;
         font-size: 20px;
         font-weight: 700;
         line-height: 24px;
         padding-right: 50px;
      }
      .action-buttons {
         margin-top: 40px;
      }
      @media screen and (max-width: 768px) {
         width: 100%;
         display: flex;
         flex-direction: column;
         align-items: center;
         img {
            width: 240px;
            height: 128px;
         }
         h2 {
            font-size: 25px;
            line-height: 30px;
            text-align: center;
            margin: 6px 0;
         }
         p {
            font-size: 14px;
            padding-right: 0px;
            text-align: center;
         }
      }
   }
   .bournvita-img {
      width: 40%;
      img {
         height: 400px;
         transform: translateY(100px);
      }
      @media screen and (max-width: 768px) {
         width: 100%;
         img {
            margin-bottom: -5px;
            width: 90%;
            height: auto;
            margin-top: 20px;
            transform: translateY(0);
         }
      }
   }
   @media screen and (max-width: 768px) {
      flex-direction: column;
      padding-left: 10px;
      padding-right: 10px;
      padding-top: 0px;
   }
`;

export const AfricaFestDividerSmall = styled(AfricaFestDivider)`
   display: flex;
   justify-content: center;
   color: #836085;
   .bournvita-text {
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
         cursor: pointer;
      }
      h2 {
         text-align: center;
      }
   }
`;

export const ActionButtons = styled.div`
   display: flex;
   align-items: center;
   gap: 20px;
   @media screen and (max-width: 768px) {
      flex-direction: column;
   }
`;

export const AfricaFestInfoSectionContainer = styled.div`
   width: 100%;
   max-width: 600px;
   margin-top: 25px;
   .no-margin {
      margin-top: 30px;
      padding: 30px 30px 0;

      ${responsive("$medium")`
         padding: 1rem;
         margin-top: 0;
      `};
   }
   .powered {
      font-weight: 400;
      font-size: 16px;
      line-height: 20px;
      color: #9d9595;
      margin-top: 37px;
   }
   .enquiries {
      font-weight: 400;
      font-size: 16px;
      line-height: 20px;
      color: #9d9595;
   }
   .advert-footer {
      margin-top: 28px;
      display: flex;
      gap: 20px;
      margin-bottom: 139px;
      align-items: center;
      .logo-cover {
         height: 63px;
         padding-top: 28px;
      }
      .logo-cover1 {
         height: 63px;
      }
   }

   form.bootcamp-form {
      width: 100%;
      border-radius: 5px;
      margin: 0 auto;

      // padding: 2rem;
      ${responsive("$medium")`
         margin: 0 auto 3rem;
      `};
      > div {
         width: 100%;
      }
   }
   @media screen and (max-width: 768px) {
      /* padding-left: 10px;
      padding-right: 10px; */
      margin-top: 20px;
   }
`;

export const AddressFormContainer = styled.div`
   background-color: #fff !important;
   h1 {
      font-size: 24px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      color: #444;
      text-align: center;
   }
   .confirm {
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 28px;
      color: #444;
      margin-bottom: 30px;
      text-align: center;
   }

   form.bootcamp-form {
      width: 100%;
      box-shadow: 0 3px 25px rgb(0 0 0 / 4%);
      border-radius: 5px;
      padding: 2rem;
      margin: 0 auto;

      ${responsive("$medium")`
         padding: 2rem;
         margin: 0 auto 3rem;
      `};
   }
`;
